import {
	CheckCircleIcon,
	ExclamationTriangleIcon,
	XCircleIcon,
} from '@heroicons/react/24/outline';
import cn from 'classnames';
import PropTypes from 'prop-types';

const Alert = ({ message, type = 'error' }) => {
	return (
		<div
			role="alert"
			className={cn('alert', {
				'alert-error': type === 'error',
				'alert-success': type === 'success',
				'alert-warning': type === 'warning',
			})}
		>
			{type === 'error' && (
				<XCircleIcon data-testid="XCircleIcon" className="block w-6 h-6" />
			)}
			{type === 'success' && (
				<CheckCircleIcon
					data-testid="CheckCircleIcon"
					className="block w-6 h-6"
				/>
			)}
			{type === 'warning' && (
				<ExclamationTriangleIcon
					data-testid="ExclamationTriangleIcon"
					className="block w-6 h-6"
				/>
			)}
			<span>{message}</span>
		</div>
	);
};

Alert.propTypes = {
	message: PropTypes.string.isRequired,
	type: PropTypes.string,
};

export default Alert;
